import { ChangeEvent, useEffect, useState } from 'react';
import { IOrderFilters } from '../useOrders';
import { useFamiliesFilters } from './useFamiliesFilters';
import { useGroupsFilters } from './useGroupsFilters';

export const useGroupsAndFamiliesFilters = () => {
  const [selectedGroup, setSelectedGroup] = useState(0);
  const [cdGrupo, setCdGrupo] = useState(0);
  const [cdDiv, setCdDiv] = useState(0);
  const [selectedFamily, setSelectedFamily] = useState(0);
  const [areFamilyFiltersActive, setAreFamilyFiltersActive] = useState(false);

  const { groups, groupsError } = useGroupsFilters();
  const { families } = useFamiliesFilters({ cdGrupo, cdDiv, areFamilyFiltersActive });

  const disableFamilyFilters = () => setAreFamilyFiltersActive(false);

  const handleChangeGroups = (e: ChangeEvent<HTMLInputElement>) => {
    setSelectedGroup(parseInt(e.target.value));
    setAreFamilyFiltersActive(true);
  };

  const handleChangeFamilies = (e: ChangeEvent<HTMLInputElement>) => {
    setSelectedFamily(parseInt(e.target.value));
  };

  const setFamilyQueryParams = () => {
    const { cd_grupo, cd_div } = groups[selectedGroup];
    setCdGrupo(cd_grupo);
    setCdDiv(cd_div);
  };

  const clearGroupAndFamilyFilters = () => {
    setSelectedGroup(0);
    setSelectedFamily(0);
    setAreFamilyFiltersActive(false);
  };

  const getGrupoFamiliaFilters = () => {
    if (selectedGroup !== 0 && selectedFamily !== 0) {
      const filters: IOrderFilters = { GEPDescription: cdGrupo, divisionId: cdDiv, familyId: selectedFamily };
      return filters;
    }
    if (selectedGroup !== 0) {
      const filters: IOrderFilters = { GEPDescription: cdGrupo, divisionId: cdDiv };
      return filters;
    }
  };

  useEffect(() => {
    if (groups.length) {
      setFamilyQueryParams();
    }
  }, [selectedGroup]);

  return {
    groups,
    groupsError,
    selectedGroup,
    handleChangeGroups,
    families,
    selectedFamily,
    handleChangeFamilies,
    areFamilyFiltersActive,
    disableFamilyFilters,
    clearGroupAndFamilyFilters,
    getGrupoFamiliaFilters
  };
};
